import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from '../../../../services/shared/shared.service';

declare let LibraryThingConnector;

@Component({
  selector: 'syndetics-fullrecord',
  templateUrl: './syndetics-fullrecord.component.html',
  styleUrls: ['../../details.component.scss'],
})
export class SyndeticsFullRecordComponent implements OnInit {
  /**   Displays Syndetics for the first isbn supplied   */
  @Input() isbn: string | string[];
  @Input() label: string;
  @Input() id: string;

  private _isbn: string;

  constructor(private _sharedService: SharedService) {}

  async ngOnInit(): Promise<void> {
    if (Array.isArray(this.isbn)) {
      this._isbn = this.isbn[0];
    } else {
      this._isbn = this.isbn;
    }

    this.initializeSyndeticsUnbound();
  }

  async initializeSyndeticsUnbound(): Promise<void> {
    window['unboundInit'] = async () => {};
    if (window['LibraryThingConnector']) {
      // LibraryThingConnector component has issues rendering when it already exists, so destroy needs to be called
      // Speculating that this library is not designed for a SPA, but rather a standard HTML
      LibraryThingConnector.destroy();
    }

    // current redirects to `https://ltfl.librarything.com/syndeticsunbound/connector/initiator.php?a_id=${this.id}`;
    await this._sharedService.addScriptToIndex(
      'syndeticsUnboundScript',
      `https://unbound.syndetics.com/syndeticsunbound/connector/initiator.php?a_id=${this.id}`,
    );
    LibraryThingConnector.runUnboundWithMetadata({ isbn: this._isbn });
  }
}
